import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Phone, Envelope, NotePencil } from "@phosphor-icons/react";
import api from "../lib/api";

export default function ContactOfficeCard() {
  const navigate = useNavigate();
  const [canLog, setCanLog] = useState(false);
  useEffect(() => {
    api.get("/call-log/permission").then((r) => setCanLog(!!r.data.allowed)).catch(() => setCanLog(false));
  }, []);
  return (
    <div className="mb-6 rounded-xl border-2 border-primary/30 bg-white p-6 shadow-sm" data-testid="contact-office-card">
      <p className="font-heading text-sm font-semibold text-stone-900">Contact the office</p>
      <p className="mt-1 text-xs text-stone-500">
        Questions about your schedule, a client, or anything at all — we want to hear from you.
        Emergencies: call 911 first, then the office.
      </p>
      <div className="mt-3 flex flex-wrap gap-2">
        <a href="tel:8007196912"
          className="inline-flex items-center gap-1.5 rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground transition-transform hover:scale-95"
          data-testid="contact-office-call">
          <Phone size={15} weight="bold" /> Call 800-719-6912
        </a>
        <a href="mailto:kelly@silverhomecare.com"
          className="inline-flex items-center gap-1.5 rounded-full border border-stone-300 px-4 py-2 text-sm font-medium text-stone-700 transition-colors hover:bg-stone-900 hover:text-white"
          data-testid="contact-office-email">
          <Envelope size={15} /> Email the office
        </a>
        <a href="tel:2675470310"
          className="inline-flex items-center gap-1.5 rounded-full border border-stone-300 px-4 py-2 text-sm font-medium text-stone-700 transition-colors hover:bg-stone-900 hover:text-white"
          data-testid="contact-office-overnight">
          <Phone size={15} /> Overnight line 267-547-0310
        </a>
        {canLog && (
          <button onClick={() => navigate("/call-log")}
            className="inline-flex items-center gap-1.5 rounded-full border border-primary/40 bg-primary/5 px-4 py-2 text-sm font-medium text-primary transition-colors hover:bg-primary hover:text-primary-foreground"
            data-testid="contact-office-log-note">
            <NotePencil size={15} /> Log a call / note
          </button>
        )}
      </div>
    </div>
  );
}
